import type { Components, Theme } from '@mui/material/styles';

export const listItemTextTheme: Components<Theme>['MuiListItemText'] = {
  styleOverrides: {
    primary: ({ theme }) => ({
      color: theme.vars.palette.semantic.text.primary
    }),
    secondary: ({ theme }) => ({
      fontSize: '14px',
      color: theme.vars.palette.semantic.text.caption
    })
  }
};

export const listItemAvatarTheme: Components<Theme>['MuiListItemAvatar'] = {
  styleOverrides: {
    root: {
      minWidth: 'unset',
      marginRight: '12px'
    }
  }
};

export const listItemIconTheme: Components<Theme>['MuiListItemIcon'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiSvgIcon-root': {
        color: theme.vars.palette.semantic.text.secondary
      }
    })
  }
};
